import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingTagsKeys } from './query-key-factory';

export type UpsertMarketingTagRequest = {
  MarketingTagId: number;
  TagName: string;
};

export type UpsertMarketingTagResult = {
  MarketingTagId: number;
  TagName: string;
};

export function useUpsertMarketingTagMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpsertMarketingTagRequest) =>
      postData<UpsertMarketingTagRequest, UpsertMarketingTagResult>({
        endpoint: 'api/marketing-campaign/upsert-marketing-tag',
        payload,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: marketingTagsKeys.all });
    },
  });
}
